import { validatePhoneArray } from 'services/forms';
import i18n from 'services/i18n';

export default values => {
  const errors = {};

  if (values.email) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = i18n.t('validation:invalidEmail');
    }
  }

  if (!values.firstName) {
    errors.firstName = i18n.t('validation:fieldRequired');
  }

  if (!values.lastName) {
    errors.lastName = i18n.t('validation:fieldRequired');
  }

  errors.patientPhone = validatePhoneArray(values.patientPhone);

  if (!values.alternateFirstName) {
    errors.alternateFirstName = i18n.t('validation:fieldRequired');
  }

  if (!values.alternateLastName) {
    errors.alternateLastName = i18n.t('validation:fieldRequired');
  }

  errors.alternatePhone = validatePhoneArray(values.alternatePhone);

  if (!values.caregiverFirstName) {
    errors.caregiverFirstName = i18n.t('validation:fieldRequired');
  }

  if (!values.caregiverLastName) {
    errors.caregiverLastName = i18n.t('validation:fieldRequired');
  }

  errors.caregiverPhone = validatePhoneArray(values.caregiverPhone);

  return errors;
};
